module.exports = __webpack_public_path__ + "img/xl_gansu.ef4ab26a.png";